import { Mutex } from 'async-mutex'

/**
 * Serializes token refresh across the whole app: baseQueryWithReauth and the
 * streaming endpoints' getFreshIdToken share this mutex so only one refresh
 * runs at a time and every other request waits it out.
 */
export const loginProcessMutex = new Mutex()
